import React from "react";

const TenderingDetailContext = React.createContext({
  detail: undefined,
  projectState: undefined,
  refresh: () => {},
  togglePayment: (price) => {},
  paymentTerms: [],
});

export default TenderingDetailContext;
